import { useState, useEffect } from 'react';

function getWindowDimensions(): { width: number; height: number; isSmartphone: boolean } {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
    isSmartphone: width < 1024,
  };
}

export default function useWindowDimensions(): { width: number; height: number; isSmartphone: boolean } {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize(): void {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
